import { View } from '../../../Models/View';

export const ViewsReducerName = 'views';

export interface IViewsState {
  views: View[] | null;
  isLoading: boolean;
  errorMessage: string | null;
}
